export const VALIDATE_BANK_ACCOUNT_DETAILS = 'VALIDATE_BANK_ACCOUNT_DETAILS';
export const GET_BANK_ACCOUNT_VALIDATION_STATUS = 'GET_BANK_ACCOUNT_VALIDATION_STATUS';
export const GET_BANK_ACCOUNT_VALIDATION_STATUS_POLL = 'GET_BANK_ACCOUNT_VALIDATION_STATUS_POLL';
export const UPLOAD_KYC_DOCUMENT = 'UPLOAD_KYC_DOCUMENT';
export const GET_KYC_INFO = 'GET_KYC_INFO';
export const INITIATE_KYC = 'INITIATE_KYC';
